import type { VCardCategory } from "../types/vcard";

// Hub categories are parent landing pages without their own SmartTag profile
// fields. Document attachments must NEVER be mounted on hub categories — only
// on concrete leaf categories (e.g. snowGear_boots, not snowGear).
//
// Adding a new hub category here is the single source of truth; the attachment
// registry validates `supportedCategories` against this set at module load.
export const HUB_VCARD_CATEGORIES: ReadonlySet<VCardCategory> =
  new Set<VCardCategory>(["snowGear"]);

export const isLeafCategory = (category: VCardCategory): boolean =>
  !HUB_VCARD_CATEGORIES.has(category);

export const isHubCategory = (category: VCardCategory): boolean =>
  HUB_VCARD_CATEGORIES.has(category);
